/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import Config from 'config'
import { resizeService } from '@/helpers/utils'

export default {
  setCurrentProductForInstantSearch (state, product) {
    // add resize mediagallery
    if (product && product.media_gallery && product.media_gallery.length) {
      const { width, height, quality, crop } = Config.Theme.productOpt.imageCrop
      for (let i in product.media_gallery) {
        product.media_gallery[i].urlResize = `${resizeService(product.media_gallery[i].url)}?${crop ? 'crop=true' : ''}&width=${width}${height ? '&height=' + height : ''}&q=${quality}`
      }
    }
    state.instantSearch = product
  }
}
